import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowLeft, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { staggerParent, staggerItem } from '../lib/motion';
import { useCart } from '../context/CartContext';
import { createCheckout } from '../lib/api';

// Redirects straight to Stripe-hosted checkout (address, card & tax handled by Stripe).
const Checkout = () => {
  const { items } = useCart();
  const [error, setError] = useState('');
  const started = useRef(false);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    if (started.current || items.length === 0) return;
    started.current = true;
    (async () => {
      try {
        const payload = items.map((i) => ({ id: i.id, quantity: i.quantity, length: i.length, color: i.color }));
        const { checkout_url } = await createCheckout(payload, window.location.origin);
        window.location.href = checkout_url;
      } catch {
        setError('We could not start checkout. Please return to your bag and try again.');
      }
    })();
  }, [items]);

  if (items.length === 0) {
    return (
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="max-w-[1400px] mx-auto px-6 py-28 text-center">
        <h1 className="font-display text-4xl text-[#1a1a1a] mb-4">Your bag is empty</h1>
        <Link to="/shop" className="btn-gold inline-block px-8 py-3.5"><span>Shop Now</span></Link>
      </motion.div>
    );
  }

  return (
    <motion.div
      variants={staggerParent(0.12)} initial="hidden" animate="show"
      className="max-w-[1400px] mx-auto px-6 py-32 text-center" data-testid="checkout-redirect">
      <motion.div variants={staggerItem}>
        <Link to="/cart" className="inline-flex items-center gap-2 overline text-[0.65rem] text-[#6b6459] hover:text-[#a8823c] mb-10"><ArrowLeft size={15} /> Back to Bag</Link>
      </motion.div>
      {error ? (
        <motion.p variants={staggerItem} className="font-body text-red-500 max-w-md mx-auto">{error}</motion.p>
      ) : (
        <motion.div variants={staggerItem} className="flex flex-col items-center gap-4">
          <Loader2 size={34} className="text-[#c6a15b] animate-spin" />
          <p className="font-display text-2xl text-[#1a1a1a] flex items-center gap-2"><Lock size={18} className="text-[#c6a15b]" /> Redirecting to secure payment…</p>
          <p className="font-body text-sm text-[#6b6459]">Please wait while we take you to Stripe.</p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default Checkout;
